<template>
  <shared-product-card :product="product" :image="image" :to="{ path: `/ecommerce/ecomece/products/${product.productId}` }"/>
</template>

<script>
  import SharedProductCard from '@/components/ProductProvide/List/Card/Shared'

  export default {
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    computed: {
      image () {
        let variationWithImage = this.product.variations.find(variation =>
          variation.images !== null && variation.images.length
        )

        if (variationWithImage === undefined) {
          return ''
        }

        return variationWithImage.images[0]
      }
    },
    components: {
      SharedProductCard
    }
  }
</script>



// WEBPACK FOOTER //
// Ecomece.vue?4591785b